import type CharmSuggestionsStore from '../schema/CharmSuggestionsStore';
import store from '../store';
import { action } from 'satcheljs/lib/legacy';

export interface SetCharmSuggestionsHighlightedIndex {
    store: CharmSuggestionsStore;
}

/**
 * Updates the value of the highlighted index
 */
export default action('setCharmSuggestionsHighlightedIndex')(
    function setCharmSuggestionsHighlightedIndex(
        isIncrement: boolean,
        state: SetCharmSuggestionsHighlightedIndex = { store: store }
    ) {
        // We only want to set the index if the suggestions are being shown
        if (state.store.shouldShowSuggestions) {
            let newIndex;
            if (isIncrement) {
                newIndex = state.store.highlightedIndex + 1;
                // If the index is past the length of the array it resets to the first element
                if (newIndex >= state.store.suggestions.length) {
                    newIndex = 0;
                }
            } else {
                newIndex = state.store.highlightedIndex - 1;
                // If the index is negative, it resets to the last element
                if (newIndex < 0) {
                    newIndex = state.store.suggestions.length - 1;
                }
            }
            state.store.highlightedIndex = newIndex;
        }
    }
);
